import axios from "axios";
import React, { useEffect, useState } from "react";
import CXlogo from "../../../Assets/Images/Logo-small.svg";
import { Config } from "../../../Config";

const StepIndicator = (props) => {
  const [FirstName, setFirstName] = useState();

  useEffect(() => {
    getUserInfo();
  }, []);

  const getUserInfo = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/profile",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setFirstName(Res.data.firstName);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const displayStep = () => {
    if (props.CurrentStep === 1) {
      return translateText("wizard_step_1_title");
    } else if (props.CurrentStep === 2) {
      return translateText("wizard_step_2_title");
    } else if (props.CurrentStep === 3) {
      return translateText("wizard_get_started");
    }
  };
  const switchLine2Status = () => {
    if (props.CurrentStep < 2) {
      return <div className="step-activity-indicator"></div>;
    } else if (props.CurrentStep === 2) {
      return <div className="step-activity-indicator active-indicator"></div>;
    } else if (props.CurrentStep > 2) {
      return <div className="step-activity-indicator passed-step"></div>;
    }
  };
  const switchRadio2Status = () => {
    if (props.CurrentStep < 2) {
      return <div className="radio-btn"></div>;
    } else if (props.CurrentStep === 2) {
      return <div className="radio-btn radio-active"></div>;
    } else if (props.CurrentStep > 2) {
      return (
        <div className="radio-btn passd-radio">
          <i className="feather-check"></i>
        </div>
      );
    }
  };
  const displayGreetings = () => {
    let Time = new Date().getHours();
    if (Time > 5 && Time <= 12) {
      return translateText("good_morning");
    } else if (Time > 12 && Time <= 16) {
      return translateText("good_afternoon");
    } else if (Time > 16 && Time <= 19) {
      return translateText("good_evening");
    } else {
      return translateText("good_night");
    }
  };

  return (
    <div className="step-indicator">
      <img alt="" className="cx-logo" src={CXlogo} />
      <div className="indicator-wrapper">
        <h1 className="step-title">{displayStep()}</h1>
        {FirstName === undefined ? null : (
          <h1 className="greetings">
            {displayGreetings()} {FirstName}!
          </h1>
        )}
        <section className="step-item">
          <div
            className={
              props.CurrentStep === 1
                ? "step-activity-indicator active-indicator"
                : "step-activity-indicator passed-step"
            }
          ></div>
          <div
            className={
              props.CurrentStep === 1
                ? "radio-btn radio-active"
                : "radio-btn passd-radio"
            }
          >
            {props.CurrentStep > 1 ? <i className="feather-check"></i> : null}
          </div>
          <p className={props.CurrentStep === 1 ? "active-step-title" : ""}>
            {translateText("wizard_step_1_text")}
          </p>
        </section>
        <section className="step-item">
          {switchLine2Status()}
          {switchRadio2Status()}
          <p className={props.CurrentStep === 2 ? "active-step-title" : ""}>
            {translateText("wizard_step_2_text")}
          </p>
        </section>
        <section className="step-item">
          <i
            className="feather-log-out"
            onClick={() => props.ToggleLogout()}
          ></i>
          <div
            className={
              props.CurrentStep === 3
                ? "step-activity-indicator active-indicator"
                : "step-activity-indicator"
            }
          ></div>
          <div
            className={
              props.CurrentStep === 3 ? "radio-btn radio-active" : "radio-btn"
            }
          ></div>
          <p className={props.CurrentStep === 3 ? "active-step-title" : ""}>
            {translateText("wizard_get_started")}
          </p>
        </section>
      </div>
    </div>
  );
};

export default StepIndicator;
